
import React from 'react'
import ArgonBox from "components/ArgonBox";
import Table from "examples/Tables/Table";

// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import { useState,useEffect } from "react";

import TutoProfileCard from './TutoProfileCard';
import TeachingExperienceTableData from "./data/TeachingExperienceTableData"
import { useParams } from 'react-router-dom';

function BasicDetails() {

 const{ id } = useParams()
 console.log("teaching experience:", id);

 const handleDeleteClick = ()=>{
  console.log("delete")
 }

const {columns,rows} = TeachingExperienceTableData(id,handleDeleteClick);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const toggleStatus = (item) => {
    if (statusSelected.includes(item)) {
      setStatusSelected(statusSelected.filter((i) => i !== item));
    } else {
      setStatusSelected([...statusSelected, item]);
    }
  };

  return (
    <ArgonBox>

      {/* <TutoProfileCard/> */}

       <ArgonBox mt={5}
                          sx={{
                            "& .MuiTableRow-root:not(:last-child)": {
                              "& td": {
                                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                  `${borderWidth[1]} solid ${borderColor}`,
                              },
                            },
                          }}
                        >
                          <Table columns={columns} rows={rows} />
                        </ArgonBox>


    </ArgonBox>
  )
}

export default BasicDetails